import { render, staticRenderFns } from "./ReminderNotes.vue?vue&type=template&id=4def8926"
import script from "./ReminderNotes.vue?vue&type=script&lang=ts"
export * from "./ReminderNotes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports